module.exports = __webpack_public_path__ + "static/media/ehealth-red-popup-desktop.2ea934e8.png";